import TechnologyListWithCreate from './TechnologyListWithCreate'

export default TechnologyListWithCreate
